<template>
  <div class="px-[16px]">
    <div
      class="flex-between py-[12px] text-16 font-semibold"
      style="border-bottom: 1px solid var(--back-4)"
    >
      {{ $t('cong-tuan-dui-kong-jian-she-wei-pin-pai-gui-fan') }}
      <CloseOutlined :class="CloseIconClass" @click="cancel" />
    </div>
    <div class="flex-between my-[16px]">
      <div class="label text-font-50">
        {{ $t('tuan-dui-kong-jian') }} >
        <span class="text-font-1">{{ label }}</span>
      </div>
      <div class="flex-center">
        <CheckAll
          v-if="list.length > 0"
          :list="list"
          :checkList="checkList"
          @check-all-change="checkAllChange"
        />
        <!-- <a-button
          v-if="isTemplate"
          type="primary"
          class="ml-[20px]"
          :disabled="upLoading"
          @click="open()"
        >
          <PlusOutlined /> 上传
        </a-button> -->
      </div>
    </div>
    <a-checkbox-group
      v-model:value="checkList"
      class="flex gap-[20px_15px] flex-wrap h-[43vh] overflow-y-auto mb-[16px] -mr-[10px] pr-[10px]"
    >
      <div v-for="x in list" :key="x.id" class="relative w-[134px]">
        <a-checkbox :value="x.id" class="absolute top-[9px] right-[9px]" />
        <div
          class="w-[134px] h-[134px] rounded-[8px] overflow-hidden flex-center bg-back-4"
          @click.stop="handClick(x)"
        >
          <Resource
            v-if="x.resource_type === RESOURCE_TYPE.FONT"
            class="h-[24px]"
            :src="x.cover_url"
            :transform-resource="transformImage"
          />
          <Resource
            v-else-if="x.resource_type === RESOURCE_TYPE.MUSIC"
            class="w-full h-full object-cover"
            :src="musicIcon"
          />
          <Resource
            v-else
            class="max-w-full max-h-full"
            :src="x.cover_url"
            :transform-resource="transformImage"
          />
        </div>

        <div
          class="flex-between mt-[12px] text-14 text-font-50 overflow-hidden"
        >
          <span class="truncate flex-1 mr-[6px]">
            {{ x.name }}
          </span>
          <span>{{ x.config.size_format }}</span>
        </div>
      </div>
      <EmptyView v-if="list.length === 0" style="min-height: 100%" />
      <div
        v-if="loading"
        class="w-full h-full absolute flex-center bg-back-1 bg-opacity-50"
      >
        <a-spin />
      </div>
    </a-checkbox-group>
    <div
      class="flex justify-end gap-x-[10px] p-[12px]"
      style="border-top: 1px solid var(--back-4)"
    >
      <a-button type="primary" ghost @click="cancel">
        {{ $t('qu-xiao') }}
      </a-button>
      <a-button
        type="primary"
        :disabled="!checkList.length"
        @click="ok(checkList)"
      >
        {{ $t('que-ren') }}
      </a-button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getModalList } from '~/api'
import { CheckAll, type DataType } from '~/features/pageList'
import { CloseIconClass } from '~/hooks/useModal/modals/closeIcon'
import musicIcon from '~/assets/svg/music.svg?url'

const props = defineProps<{
  upload: {
    accept?: string
    params?: DataType
  }
  cancel: () => void
  ok: (ids: number[]) => void
}>()

const { $t } = useNuxtApp()

const label = computed(() => {
  if (!props.upload?.params) {
    return ''
  }

  const { model_type, resource_type } = props.upload.params
  if ((model_type as any) === COLLECTION_MAP.PIECES_TEMPLATE) {
    return $t('mo-ban')
  }

  return RESOURCE_TYPE_NAME_TRANSLATE()[resource_type!]
})

const loading = ref(false)
const list = ref<any[]>([])
const checkList = ref<any[]>([])

const checkAllChange = (v: boolean) => {
  checkList.value = v ? list.value.map((item) => item.id) : []
}

const handClick = (record: Record<string, any>) => {
  if (checkList.value.includes(record.id)) {
    checkList.value = checkList.value.filter((id) => id !== record.id)
  } else {
    checkList.value.push(record.id)
  }
}

const reload = async () => {
  loading.value = true
  try {
    const { model_type, resource_type } = props.upload?.params as any
    const isTemplate = resource_type === RESOURCE_TYPE.TEMPLATE
    const res = await getModalList({
      model_type,
      resource_type: !isTemplate ? resource_type : undefined,
      is_template: isTemplate ? 1 : undefined,
    })
    if (res.code !== 0) {
      return
    }

    list.value = (res.data || []).filter((item) => !item.brand_guidelines)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  reload()
})
</script>

<style lang="scss" scoped></style>
